"use client";

import Link from "next/link";

export default function HeroSection() {
  return (
    <section className="bg-background pt-32 xl:pt-[190px] pb-[120px] px-4 sm:px-6 lg:px-10">
      <div className="w-full max-w-[1440px] mx-auto">
        <div className="w-full flex flex-col lg:flex-row items-start justify-between gap-10 xl:gap-0 xl:h-[618px]">
          
          {/* Left Content */}
          <div className="flex flex-col justify-between gap-10 lg:gap-0 w-full xl:w-[710px] xl:h-[618px]">
            {/* Description */}
            <div className="flex flex-col gap-8 xl:gap-[60px]">
              {/* Heading */}
              <div className="flex flex-col gap-4 xl:gap-6">
                <h1 className="font-oswald font-medium text-[32px] sm:text-[42px] xl:text-[60px] leading-[1.2] xl:leading-[80px] tracking-[0.2px] uppercase text-neutral-500">
                  SIMPLE, SAFE & FAST GUNIWHEEL™ INSTALLATION
                </h1>
              </div>

              <div className="flex flex-col gap-4 xl:gap-6">
                <p className="font-roboto font-normal text-[14px] sm:text-[16px] xl:text-[18px] leading-[25px] text-neutral-300">
                  Guniwheel™ provides a safe alternative to jack stands and other mounting methods that keep vehicles immobile. It is engineered to support secure mounting and controlled movement during repairs or workshop operations.
                </p>
                
                <p className="font-roboto font-normal text-[14px] sm:text-[16px] xl:text-[18px] leading-[25px] text-neutral-300">
                  Guniwheel™ is <span className="font-bold">not a spare tire and not designed for road driving.</span> It is only intended for low-speed movement within workshops or parking areas, with a maximum speed limit of 5 mph / 8 km/h.
                </p>
                
                <p className="font-roboto font-normal text-[14px] sm:text-[16px] xl:text-[18px] leading-[25px] text-neutral-300">
                  Before installation, always check that the hub or rotor is properly attached and free from damage. Guniwheel™ 45 and 55 models are fully patented, protected under U.S. Patent #D874387.
                </p>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-[12px] w-full xl:h-[60px]">
              <Link
                href="https://youtu.be/dBaLqbFDqeM"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-primary hover:bg-primary/90 text-white font-oswald font-medium text-[14px] xl:text-[16px] uppercase px-6 py-3 rounded-[8px] flex items-center justify-center gap-2 transition-colors h-[60px]"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
                WATCH INSTALLATION VIDEO
              </Link>
              
              <Link
                href="/products"
                className="bg-neutral-500 hover:bg-neutral-600 text-white font-oswald font-medium text-[14px] xl:text-[16px] uppercase px-6 py-3 rounded-[8px] flex items-center justify-center transition-colors h-[60px]"
              >
                EXPLORE OUR PRODUCTS
              </Link>
            </div>
          </div>

          {/* Right Video/Image */}
          <div className="relative w-full lg:w-[580px] h-[300px] sm:h-[450px] xl:h-[618px] rounded-[12px] overflow-hidden">
            <img
              src="/image/installation/hero-video.webp"
              alt="Guniwheel Installation"
              className="w-full h-full object-cover"
            />
            <Link
              href="https://youtu.be/dBaLqbFDqeM"
              target="_blank"
              rel="noopener noreferrer"
              className="absolute bottom-4 right-4 bg-white hover:bg-gray-100 rounded-md px-4 py-2 flex items-center gap-2 transition-colors"
            >
              <svg className="w-4 h-4 text-red-600" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
              <span className="font-roboto font-medium text-[12px] uppercase text-neutral-900">
                WATCH ON YOUTUBE
              </span>
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
}
